import React, { useState } from "react";
import { Label, InputGroup, Input, InputGroupText } from "reactstrap";

export const PasswordInputComponent = ({
  field,
  form: { touched, errors },
  label,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div >
      <Label>{label}</Label>
      <InputGroup>
        <Input
          {...field}
          {...props}
          type={showPassword ? "text" : "password"}
          autoComplete="new-password"
          invalid={touched[field.name] && errors[field.name]}
        />
        <InputGroupText onClick={() => setShowPassword(!showPassword)}
          style={{ cursor: "pointer", backgroundColor: "transparent" }}>
          <i className={showPassword ? "las la-eye-slash" : "las la-eye"}
          />
        </InputGroupText>
      </InputGroup>
      {touched[field.name] && errors[field.name] && (
        <div className="error"> {errors[field.name]} </div>
      )}
    </div>
  );
};